/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, useState } from 'react';
import useIsPrinting from '../../utilities/PrintUtilities';
import { siteFilterId } from '../filters';
import { PageLink } from '../links/Links';

/**
 * Expandable Sites list component. It expects prop.sites to be an array of objects with "name" and "_id" properties.
 * @param props
 * @returns {*}
 * @constructor
 */
export default function PropertiesSiteList(props) {
    const { value, excludedFilters = [], maxLines = 10 } = props;
    const [expanded, setExpanded] = useState(false);
    const isPrinting = useIsPrinting();
    return useMemo(() => {
        return (
            <div>
                {value.slice(0, expanded || isPrinting ? value.length : maxLines).map((site) => (
                    <div key={site.uuid || site._id}>
                        <PageLink
                            target="/site-detail"
                            targetName={site.name}
                            filters={[{ name: siteFilterId, uuid: site.uuid || site._id }]}
                            excludedFilters={excludedFilters}
                        />
                    </div>
                ))}
                {maxLines < value.length && !expanded && !isPrinting && (
                    <a href="#" onClick={() => setExpanded(true)}>
                        {`Show ${value.length - maxLines} more...`}
                    </a>
                )}
            </div>
        );
    }, [expanded, maxLines, value, isPrinting, excludedFilters]);
}
